<template>
  <div class="marketplace-container" ref="top">
    <h1 class="page-header text-center">brands</h1>
    <section class="nav-display-container">
      <p v-if="errorMessage">{{errorMessage}}</p>
      <brands-marketplace-navigation v-if="marketplaceDataLoaded" :showStateNav="showStateNav" :showSponsoredNav="showSponsoredNav" :showStoreNav="showStoreNav" @scrollMeTo="scrollMeToClick" />
      <brands-marketplace-display @closeModal="showModal = false" :showModal.sync="showModal" :isMobile.sync="isMobile" :marketplaceDisplay="marketplaceDisplay" />
    </section>

    <section class="mobile-header">
      <h1>brands</h1>
      <h2>by springbig</h2>
    </section>

    <div v-if="stateSlides && marketplaceDataLoaded">
      <section class="states" v-for="(state, index) in stateSlides" :key="index">
        <p v-if="state.slides && marketplaceDataLoaded" class="carousel-title">{{state.name}} cannabis brands</p>
        <carousel :selected="selected" :slides="state.slides" @update:selected="syncSlide($event)">
          <template #new-icon>
            <img class="new-icon" :src="newIcon" alt="new-icon">
          </template>
        </carousel>
      </section>
    </div>

    <div v-if="sponsoredSlides && marketplaceDataLoaded">
      <section class="previously-sponsored" ref="sponsored">
        <p v-if="sponsoredSlides.slides && marketplaceDataLoaded" class="carousel-title">{{sponsoredSlides.name}}</p>
        <carousel :selected="selected" :slides="sponsoredSlides.slides" @update:selected="syncSlide($event)">
          <template #new-icon>
            <img class="new-icon" :src="newIcon" alt="new-icon">
          </template>
        </carousel>
      </section>
    </div>

    <div v-if="storeSlides && marketplaceDataLoaded">
      <section class="in-store" ref="inStore">
          <p v-if="storeSlides.slides && marketplaceDataLoaded" class="carousel-title">{{storeSlides.name}}</p>
          <carousel :selected="selected" :slides="storeSlides.slides" @update:selected="syncSlide($event)">
            <template #new-icon>
              <img class="new-icon" :src="newIcon" alt="new-icon">
            </template>
          </carousel>
        </section>
    </div>

  </div>
</template>

<script>
  import { brandsMarketplaceAPI } from "../../services/api/brandsMarketplace"
  import BrandsMarketplaceNavigation from '../../components/BrandsMarketplace/BrandsMarketplaceNavigation'
  import BrandsMarketplaceDisplay from '../../components/BrandsMarketplace/BrandsMarketplaceDisplay'
  import { Carousel } from '@springbig/sb-components'
  import { isWithinInterval, subMonths, startOfDay } from 'date-fns'
  import newIcon from '../../../../assets/images/brands/new.svg'

  export default {
    name: 'BrandsMarketplace',

    components: {
      BrandsMarketplaceNavigation,
      BrandsMarketplaceDisplay,
      Carousel
    },

    data() {
      return {
        marketplaceDisplay: null,
        brandsLoading: null,
        errorMessage: '',
        model: 0,
        stateSlides: [],
        storeSlides: {},
        sponsoredSlides: {},
        selected: null,
        isMobile: false,
        showModal: false,
        showStoreNav: false,
        showSponsoredNav: false,
        showStateNav: false,
        marketplaceDataLoaded: false,
        newIcon
      }
    },

    created() {
      this.getDemoBrandDisplay()
      this.getmarketplaceDisplay()
    },

    beforeDestroy () {
      if (typeof window === 'undefined') return

      window.removeEventListener('resize', this.onResize, { passive: true })
    },

    mounted () {
      this.onResize()

      window.addEventListener('resize', this.onResize, { passive: true })
    },

    methods: {
      async getmarketplaceDisplay() {
        this.brandsLoading = true
        try {
          const marketplaceDisplay = await brandsMarketplaceAPI.getAllBrandDisplays()
          if (marketplaceDisplay[0].states.length) {
            this.showStateNav = true
            marketplaceDisplay[0].states.forEach((element) => {
              const keyName = Object.keys(element)[0]
              const state = {
                name: keyName,
                slides: []
              }

              for (let index = 0; index < element[keyName].length; index++) {
                const stateObject = element[keyName][index]
                const createdAt = new Date(stateObject.advertiser_created_at)
                const today = new Date()
                const threeMonthsAgo = subMonths(new Date(), 3)
                const monthResult = isWithinInterval(createdAt, {
                  start: threeMonthsAgo,
                  end: today
                })

                const newState = {
                  label: stateObject.display_name,
                  imgSrc: stateObject.image,
                  id: stateObject.id,
                  createdAt: stateObject.advertiser_created_at,
                }
                if (monthResult) newState["isNew"] = true
                state.slides.push(newState)
              }
              this.stateSlides.push(state)
            })
          }
          if (marketplaceDisplay[1].previously_sponsored.length) {
            this.showSponsoredNav = true
            this.createSlidesArray('sponsoredSlides', 'previously sponsored', marketplaceDisplay[1].previously_sponsored)
          }
          if (marketplaceDisplay[2].in_store.length) {
            this.showStoreNav = true
            this.createSlidesArray('storeSlides', 'in-store brands', marketplaceDisplay[2].in_store)
          }
          this.marketplaceDataLoaded = true
        } catch (error) {
            this.errorMessage = error
        }
        this.brandsLoading = false
      },

      createSlidesArray(dataProp, name, arr) {
        let state = {
          name: name,
          slides: []
        }

        arr.forEach((element) => {
          state.slides.push({
            label: element.display_name,
            imgSrc: element.image,
            id: element.id,
            createdAt: element.advertiser_created_at
          })
        })

        this[dataProp] = state
      },

      onResize () {
        this.isMobile = window.innerWidth < 900
      },

      async getDemoBrandDisplay() {
        this.brandsLoading = true
        try {
            const marketplaceDemo = await brandsMarketplaceAPI.getDemoBrandDisplay()
            this.marketplaceDisplay = marketplaceDemo
        } catch (error) {
            this.errorMessage = error
        }
        this.brandsLoading = false
      },

      async getBrandDisplay(id) {
        this.brandsLoading = true
        try {
            const marketplaceBrand = await brandsMarketplaceAPI.getBrandDisplay(id)
            this.marketplaceDisplay = marketplaceBrand
        } catch (error) {
            this.errorMessage = error
        }
        this.brandsLoading = false
      },

      scrollMeToClick(refName) {
        const element = this.$refs[refName]
        element.scrollIntoView({behavior: 'smooth'})
      },

      syncSlide($event) {
        this.selected = $event

        if (this.isMobile) {
          this.showModal = true
        } else {
          this.showModal = false
        }

        this.getBrandDisplay($event.id)
      }
    }
  }
</script>

<style>
  .nav-display-container,
  .display-images-wrapper {
    display: flex;
  }

  .swiper-button-next,
  .swiper-button-prev {
    /* override swiper */
    top: 41% !important;
  }

  .swiper-slide > img {
    height: 220px !important;
  }

  .rounded.border {
    box-shadow: 0 0 0 9px #128ff9 !important;
    border: none !important;
  }

  section.previously-sponsored .carousel-title,
  section.in-store .carousel-title {
    top: -10px
  }

  section.previously-sponsored {
    scroll-margin-top: 180px;
  }

  .nav-display-container {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: white;
    padding-bottom: 20px;
  }

  .brand-info {
    padding: 0 60px;
    width: 40em;
  }

  .marketplace-container .page-header {
    display: none;
  }

  .brand-info h2 {
    font-size: 1.5em;
    margin-top: 27px;
    font-family: 'AileronLight';
    margin-bottom: 0;
  }

  .brand-info p,
  .brand-info h2 {
    word-break: break-all;
  }

  .brand-info p {
    font-family: 'AileronThin';
    font-size: 20px;
    line-height: 26px;
  }

  .mobile-header {
    display: none;
  }

  button.sponsor {
    width: 255px;
    margin-top: 10px;
  }

  .images-container {
    display: inline-flex;
    margin-top: 35px;
  }

  .side-images img {
    width: 93px;
    height: 46px;
  }

  .carousel-title {
    margin-bottom: 10px;
    font-weight: 300;
    font-family: 'Aileronlight';
  }

  .swiper-wrapper {
    padding-top: 10px;
  }

  .slide-label {
    top: 155px !important;
    margin: 15px auto;
    word-break: break-all;
    position: unset !important;
  }

  .swiper-button-disabled {
    /* override swiper */
    display: none !important;
  }

  .new-icon {
    width: 45px;
    background-color: white;
    border-radius: 50%;
  }

  .img-container {
    margin-left: 9px;
    margin-right: 9px;
  }

  @media only screen and (max-width: 1224px) {
    section.previously-sponsored {
      scroll-margin-top: 220px;
    }
  }

  @media only screen and (max-width: 900px) {
    .carousel-title {
      margin-left: 25px;
      font-size: 22px;
      font-weight: 400;
    }

    .is-new {
      right: 7px !important;
    }

    .swiper-slide {
      margin-left: unset;
    }

    .swiper-button-next {
      /* override swiper */
      right: 18px !important;
    }

    .swiper-button-prev {
      /* override swiper */
      left: 18px !important;
    }

    .swiper-wrapper {
      padding-top: 20px;
    }

    .swiper-button-next,
    .swiper-button-prev {
      /* override swiper */
      top: 41% !important;
      outline: white !important;
      outline-width: 0 !important;
    }

    .display-images-wrapper, .links-container, .brand-info, .images-container {
      display: none;
    }

    .nav-display-container {
      position: absolute;
      background-color: unset;
    }

    .mobile-header {
      display: inline-block;
      margin-bottom: 70px;
    }

    .mobile-header h1,
    .mobile-header h2 {
      font-family: 'AileronThin';
      display: inline-block;
      color: #128ff9;
    }

    .mobile-header h1 {
      font-size: 2.5em;
      margin-left: 15px;
      margin-bottom: 0;
    }

    .mobile-header h2 {
      font-size: 20px;
      position: relative;
      bottom: 0;
    }

    .img-container {
      width: 250px;
    }
  }

  @media only screen and (max-width: 568px) {
    .swiper-slide {
      width: inherit !important;
      margin-left: inherit;
    }
  }

  @media only screen and (min-height: 980px) {
    section.previously-sponsored, section.in-store {
      scroll-margin-top: 420px;
    }
  }

  @media only screen and (min-height: 580px) {
    section.previously-sponsored, section.in-store {
      scroll-margin-top: 330px;
    }
  }

</style>
